//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { ArrowBackIcon, QuestionIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Collapse,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Icon,
  Input,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field, Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import React from "react";
import { number, object } from "yup";
import { SingleFormButton } from "../FormButtons";

const commonProps = ({ name }, { touched, errors }) => ({
  label: "Percentage increase per student",
  placeholder: "No price set",
  isInvalid: Boolean(touched[name] && errors[name]),
  errorMessage: errors[name],
});

export const AdditionalDiscounts: React.FC<{
  initialValues: { extraStudents: number };
  onBackClick: () => void;
  onEditPrice: (values: any) => void;
  isLoading?: boolean;
  currency: string;
  subject?: string;
  onSubmit: (values: any) => Promise<any>;
}> = observer(
  ({
    onBackClick,
    initialValues,
    subject,
    onEditPrice,
    isLoading,
    onSubmit,
  }) => {
    const [showBreakdown, setShowBreakdown] = React.useState(false);

    const validationSchema = object().shape({
      extraStudents: number().required(
        "Please set pricing using the button above",
      ),
    });
    return (
      <Box className="additional-student-discount">
        <Button
          mb={6}
          onClick={onBackClick}
          leftIcon={<ArrowBackIcon />}
          variant="link"
          colorScheme="blue"
        >
          Back
        </Button>

        <Stack pb={6}>
          <Text fontSize="3xl" lineHeight="shorter" fontWeight="bold" as="h1">
            Additional students
          </Text>
          <Text mt={1} color="gray.700">
            This rate applies when you have lessons with multiple students at
            the same time
          </Text>
        </Stack>

        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          key={initialValues?.extraStudents}
          validationSchema={validationSchema}
        >
          {({ handleSubmit, values }) => (
            <Form>
              <Stack mb={8} pb={20}>
                <Field
                  name="extraStudents"
                  render={({ field, form }) => {
                    return (
                      <Stack spacing="6">
                        <FormControl
                          isInvalid={commonProps(field, form).isInvalid}
                        >
                          <FormLabel>
                            {commonProps(field, form).label}
                          </FormLabel>
                          <Box
                            borderWidth="2xs"
                            borderColor="neutral.500"
                            rounded="md"
                            overflow="hidden"
                          >
                            <Flex>
                              <Input
                                isDisabled
                                height="3.5rem"
                                size="lg"
                                flex="4"
                                opacity="1"
                                rounded="none"
                                border="none"
                                fontSize="xl"
                                fontWeight={field.value ? "medium" : "normal"}
                                borderColor="neutral.700"
                                {...field}
                                {...commonProps(field, form)}
                                name={field.name}
                                onChange={({ target }) => {
                                  form.setFieldValue(field.name, target.value);
                                }}
                              />

                              <Button
                                flex={1}
                                bg="white"
                                shadow="none"
                                color="blue.500"
                                borderLeftWidth="2xs"
                                borderColor="neutral.500"
                                roundedLeft="none"
                                roundedBottomRight="none"
                                height="3.5rem"
                                onClick={() => onEditPrice(values)}
                              >
                                Edit
                              </Button>
                            </Flex>

                            {values.extraStudents ? (
                              <Stack
                                borderTopWidth="2xs"
                                borderColor="neutral.500"
                                spacing={3}
                                px={4}
                                py={3}
                                bg="neutral.200"
                              >
                                <HStack justify="space-between" align="center">
                                  <Box>
                                    <Text fontWeight="light" fontSize="xs">
                                      What this means
                                    </Text>
                                    <Text
                                      fontWeight={
                                        showBreakdown ? "semibold" : "normal"
                                      }
                                    >
                                      Extra students rate
                                    </Text>
                                  </Box>
                                  <Icon
                                    cursor="pointer"
                                    as={QuestionIcon}
                                    fontSize="xl"
                                    onClick={() =>
                                      setShowBreakdown(!showBreakdown)
                                    }
                                  />
                                </HStack>

                                <Collapse in={showBreakdown}>
                                  <Box pb={6}>
                                    When you get bookings with multiple
                                    students, your standard fee will apply to
                                    the first student, while this additional
                                    percentage will be applied to every other
                                    student.
                                  </Box>
                                </Collapse>
                              </Stack>
                            ) : null}
                          </Box>

                          <FormErrorMessage>
                            {commonProps(field, form).errorMessage}
                          </FormErrorMessage>
                        </FormControl>
                      </Stack>
                    );
                  }}
                />
              </Stack>

              <SingleFormButton
                nextText="Save pricing"
                isLoading={isLoading}
                onNextClick={handleSubmit}
              />
            </Form>
          )}
        </Formik>
      </Box>
    );
  },
);
